import { useTranslation } from 'react-i18next';

function Icon({ d, color }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d={d} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function Features() {
  const { t } = useTranslation();
  const features = [
    {
      iconBg: '#FBE3D2',
      iconColor: '#C2410C',
      iconPath: 'M12 3 L14.5 9 L21 9.5 L16 13.8 L17.7 20 L12 16.5 L6.3 20 L8 13.8 L3 9.5 L9.5 9 Z',
      title: t('feature1Title'),
      body: t('feature1Text'),
    },
    {
      iconBg: '#E4EFE0',
      iconColor: '#4A7A54',
      iconPath: 'M4 6 H20 M4 12 H20 M4 18 H13 M17 16.5 L19 18.5 L22 14.5',
      title: t('feature2Title'),
      body: t('feature2Text'),
    },
    {
      iconBg: '#E7E4F4',
      iconColor: '#5E568F',
      iconPath: 'M12 3 L20 6.5 V11 C20 16 16.5 19.5 12 21 C7.5 19.5 4 16 4 11 V6.5 Z M9 11.5 L11.5 14 L15.5 9.5',
      title: t('feature3Title'),
      body: t('feature3Text'),
    },
  ]

  return (
    <section id="about" className="bg-surface px-6 py-24 sm:py-28 lg:px-16">
      <div className="mx-auto flex max-w-[1152px] flex-col gap-14">
        <div className="flex flex-col items-center gap-3.5 text-center">
          <h2 className="text-4xl font-bold tracking-[-1px] text-ink">{t("featuresTitle")}</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col gap-4 rounded-4xl bg-cream p-8 transition-all duration-200 hover:-translate-y-1 hover:shadow-elevated"
            >
              <div
                className="flex h-[52px] w-[52px] items-center justify-center rounded-2xl"
                style={{ background: f.iconBg }}
              >
                <Icon d={f.iconPath} color={f.iconColor} />
              </div>
              <h3 className="text-[19px] font-bold text-ink">{f.title}</h3>
              <p className="text-[15px] leading-relaxed text-muted">{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
